var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSiteMapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Site mapping") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Site_mapping",
    "data-name": "Site mapping"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,3H13a3,3,0,0,0-3,3v6a1,1,0,0,0,1,1H53a1,1,0,0,0,1-1V6A3,3,0,0,0,51,3ZM12,11V6a1,1,0,0,1,1-1H51a1,1,0,0,1,1,1v5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,5H13a1,1,0,0,0-1,1v5H52V6A1,1,0,0,0,51,5ZM16,9H15a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm4,0H19a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm4,0H23a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,11H11a1,1,0,0,0-1,1V26a3,3,0,0,0,3,3H51a3,3,0,0,0,3-3V12A1,1,0,0,0,53,11ZM52,26a1,1,0,0,1-1,1H13a1,1,0,0,1-1-1V13H52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,38H38a3,3,0,0,0-3,3V58a3,3,0,0,0,3,3H58a3,3,0,0,0,3-3V41A3,3,0,0,0,58,38Zm1,20a1,1,0,0,1-1,1H38a1,1,0,0,1-1-1V41a1,1,0,0,1,1-1H58a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58,40H38a1,1,0,0,0-1,1v5H59V41A1,1,0,0,0,58,40ZM44,44H43a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm5,0H48a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm5,0H53a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,38H6a3,3,0,0,0-3,3V58a3,3,0,0,0,3,3H26a3,3,0,0,0,3-3V41A3,3,0,0,0,26,38Zm1,20a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V41a1,1,0,0,1,1-1H26a1,1,0,0,1,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,40H6a1,1,0,0,0-1,1v5H27V41A1,1,0,0,0,26,40ZM11,44H10a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm5,0H15a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm5,0H20a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45,31H33V28a1,1,0,0,0-2,0v3H19a5,5,0,0,0-5,5v3a1,1,0,0,0,2,0V36a3,3,0,0,1,3-3H45a3,3,0,0,1,3,3v3a1,1,0,0,0,2,0V36A5,5,0,0,0,45,31Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 10,
    height: 10,
    rx: 1,
    ry: 1
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37,17H29a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,21H29a1,1,0,0,1,0-2H41a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,25H29a1,1,0,0,1,0-2H45a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29,47a1,1,0,0,1-1,1H4a1,1,0,0,1,0-2H28A1,1,0,0,1,29,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,47a1,1,0,0,1-1,1H36a1,1,0,0,1,0-2H60A1,1,0,0,1,61,47Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,52H9a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17,57H9a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,52H50a1,1,0,0,1,0-2h5a1,1,0,0,1,0,2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55,57H47a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteMapping);
export default __webpack_public_path__ + "static/media/site-mapping.d23a2435.svg";
export { ForwardRef as ReactComponent };